import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Flame, CheckCircle2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const StreakBanner = () => {
  const [s, setS] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const { data } = await axios.get(`${API_URL}/api/streak/status`);
        setS(data);
      } catch (e) { console.error('Failed to load streak status:', e); }
    };
    load();
  }, []);

  if (!s) return null;

  const dayPct = Math.min(100, Math.round((s.today_questions / s.today_required) * 100));
  const weekPct = Math.min(100, Math.round((s.current_streak_days / s.days_required) * 100));

  return (
    <div className="rounded-3xl p-5 bg-gradient-to-r from-orange-50 to-amber-50 border border-orange-200 shadow-sm" data-testid="streak-banner">
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-orange-400 to-amber-500 flex items-center justify-center shadow-md shrink-0">
          <Flame className="w-6 h-6 text-white" />
        </div>
        <div className="flex-1">
          <div className="flex items-center justify-between mb-2">
            <h3 className="font-bold text-[#111827] flex items-center gap-2" style={{ fontFamily: 'Fredoka, sans-serif' }}>
              {s.current_streak_days > 0 ? `🔥 ${s.current_streak_days}-day streak going!` : 'Build your streak'}
            </h3>
            <span className="text-xs font-bold text-amber-700 bg-white/80 px-2 py-0.5 rounded-full">+{s.bonus_points} pts at {s.days_required} days</span>
          </div>
          <p className="text-xs text-[#6B7280] mb-3">
            Solve {s.today_required}+ questions every day for {s.days_required} days to win {s.bonus_points} bonus points.
          </p>

          {/* Today's progress */}
          <div className="mb-2">
            <div className="flex items-center justify-between text-xs font-bold mb-1">
              <span className="text-[#6B7280]">Today</span>
              <span className={s.today_target_met ? 'text-emerald-600 flex items-center gap-1' : 'text-[#6B7280]'}>
                {s.today_target_met && <CheckCircle2 className="w-3 h-3" />}
                {s.today_questions} / {s.today_required}
              </span>
            </div>
            <div className="h-2 rounded-full bg-orange-100 overflow-hidden">
              <div className="h-full bg-gradient-to-r from-orange-400 to-amber-500 transition-all" style={{ width: `${dayPct}%` }} />
            </div>
          </div>

          {/* Week progress */}
          <div>
            <div className="flex items-center justify-between text-xs font-bold mb-1">
              <span className="text-[#6B7280]">This streak</span>
              <span className="text-[#6B7280]">{s.current_streak_days} / {s.days_required} days</span>
            </div>
            <div className="h-2 rounded-full bg-orange-100 overflow-hidden">
              <div className="h-full bg-gradient-to-r from-orange-500 to-red-500 transition-all" style={{ width: `${weekPct}%` }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StreakBanner;
